module.exports = __webpack_public_path__ + "static/img/fluent-delete-24-regular.568c1012.svg";